/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type NPS_TYPE = "MY_TASKS" | "MY_WORK" | "NPS" | "NPS_EMOJI" | "NPS_NEW" | "OVERVIEW" | "TIME" | "TIMESHEETS" | "%future added value";
export type CreateNpsInput = {|
  personId?: ?string,
  score?: ?number,
  comment?: ?string,
  type?: ?NPS_TYPE,
  csrfToken?: ?string,
  socketClientId?: ?string,
  clientMutationId?: ?string,
|};
export type createNpsMutationVariables = {|
  input: CreateNpsInput
|};
export type createNpsMutationResponse = {|
  +createNps: ?{|
    +clientMutationId: ?string
  |}
|};
export type createNpsMutation = {|
  variables: createNpsMutationVariables,
  response: createNpsMutationResponse,
|};
*/


/*
mutation createNpsMutation(
  $input: CreateNpsInput!
) {
  createNps(input: $input) {
    clientMutationId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "CreateNpsInput!"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateNpsPayload",
    "kind": "LinkedField",
    "name": "createNps",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "clientMutationId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createNpsMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createNpsMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "createNpsMutation",
    "operationKind": "mutation",
    "text": "mutation createNpsMutation(\n  $input: CreateNpsInput!\n) {\n  createNps(input: $input) {\n    clientMutationId\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '68fb0129f7c651664b8a1cf852222c3a';

module.exports = node;
